import _ from 'lodash'
import type {PS} from '@wix/document-services-types'

function initPaths(ps: PS) {
    const pointersToSet = [
        ps.pointers.wixCode.getRoot(),
        ps.pointers.wixCode.getUndoableRoot(),
        ps.pointers.wixCode.getUndoableModifiedFileContentMap(),
        ps.pointers.wixCode.getWixCodeModel(),
        ps.pointers.wixCode.getWixCodeAppData()
    ]

    _.forEach(pointersToSet, function (pointer) {
        if (!ps.dal.isExist(pointer)) {
            // DAL does not support deep merge
            ps.dal.set(pointer, {})
        }
    })
}

export default {
    initPaths
}
